import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, UntypedFormArray, FormsModule } from '@angular/forms';
import { NgSelectComponent, NgMultiLabelTemplateDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgOptionComponent } from '@ng-select/ng-select';
import { TranslationService, I18nModule } from '@spartacus/core';
import { FilterSortModel } from 'src/app/core/model/filter-sort.model';
import { CustomProductsService } from '../../custom-products/custom-products.service';
import { DateRangePickerComponent, IDateRange, IDateRangePickerOptions } from 'ngx-daterange';
import { NgbCalendar, NgbDate, NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerI18n, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { CustomAdapter, CustomDateParserFormatter, DateRangePickerI18nService } from 'src/app/shared/services/date-range-picker-i18n.service';
import { tap, map} from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { NgFor, NgIf, NgClass, TitleCasePipe } from '@angular/common';

@Component({
    selector: 'app-shipment-filter-bar',
    templateUrl: './shipment-filter-bar.component.html',
    styleUrls: ['./shipment-filter-bar.component.scss'],
    providers: [
        { provide: NgbDatepickerI18n, useClass: DateRangePickerI18nService },
        { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
    ],
    imports: [NgSelectComponent, FormsModule, NgMultiLabelTemplateDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgbInputDatepicker, NgFor, NgOptionComponent, NgIf, NgClass, TitleCasePipe, I18nModule]
})
export class ShipmentFilterBarComponent implements OnInit {
  @ViewChild(NgSelectComponent) ngSelectComponent: NgSelectComponent;
  @ViewChild('testselect') private myselect: NgSelectComponent;
  firstFieldEmittedValue: IDateRange;
  filterSortModel: FilterSortModel;
  selectedProductType;
  selectedStatus;
  commodity;
  selectedProduct: any;
  @Input() tab: string;

  sampleStatus = [];
  sampleProductName = [];
  data: any;
  filterListSelected = [];
  statusTypes = [];
  hidebutton = false;
  productsList = [];
  loggedinUser: any;
  customerId: any;
  pageSize = 5;
  currentPage = 1;
  sidebar: boolean;
  form: UntypedFormGroup = null;
  checkedform: UntypedFormGroup;
  length: number;
  checkArray: any;
  checkedproductform: UntypedFormGroup;
  checkedstatusform: UntypedFormGroup;
  checkedcommodityform:UntypedFormGroup
  statuslength = 0;
  isStatusNull = true;
  isProductNull = true;
  productlength = 0;
  commoditylength= 0
  showClear = false;
  mobileCurrentSelection = null;
  isDisabledCheckBox = false;
  hoveredDate: NgbDate | null = null;
  startDate: NgbDate | null = null;
  endDate: NgbDate | null = null;
  nextMonth: string;
  preMonth: string;
  selectMonth: string;
  selectYear: string;
  shipmentPageData: [];
  query: string = null;
  enableLoader: boolean = true;
  searchText = null;
  displayLoading = true;
  noData = false;
  toDate: string = null;
  fromDate: string = null;
  shipmentData: any;
  shipmentDataCopy: any;
  error: string;
  shipdata: any;
  date = 0;
  clearBtn = false;
  @ViewChild('dateRangePicker', { static: true })
  dateRangePicker: DateRangePickerComponent;
  commodityType = [];
  materialList = [];
    constructor(
    private customProductService: CustomProductsService,
    private translation: TranslationService,
    private fb: UntypedFormBuilder,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private userAccountFacade: UserAccountFacade,
    private toastService: ToastrService
  ) {
    this.checkedproductform = this.fb.group({
      checkArray: this.fb.array([])
    });
    this.checkedstatusform = this.fb.group({
      checkArray: this.fb.array([])
    });
    this.checkedcommodityform = this.fb.group({
      checkArray: this.fb.array([])
    });
  }

  ngOnInit(): any {
    this.sidebar = true;
    this.showClear = false;
    this.clearBtn = false;

    this.customProductService.getHomeLinkActive(false);
    this.customProductService.scrollToTop();

    this.userAccountFacade.get().subscribe((res: any) => {
      if (res) {
        this.getShipData();
        this.customProductService.languageChange$.subscribe(data => {
          this.displayLoading = true;
          if (data != null) {
            this.statusTypes = [];

            this.productsFilterData();
            this.getShipData();
          }
        });
        this.shipmentPageData = this.shipdata;
      }
    });
    this.translation.translate('home.datePicker.nextMonth').subscribe(res => {
      this.nextMonth = res;
    });
    this.translation.translate('home.datePicker.preMonth').subscribe(res => {
      this.preMonth = res;
    });
    this.translation.translate('home.datePicker.selectMonth').subscribe(res => {
      this.selectMonth = res;
    });
    this.translation.translate('home.datePicker.selectyear').subscribe(res => {
      this.selectYear = res;
    });
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    this.userAccountFacade.get().subscribe((res: any) => {
      if (res) {
        this.getShipData();
        this.customProductService.languageChange$.subscribe(data => {
          this.displayLoading = true;
          if (data != null) {
            this.statusTypes = [];

            this.productsFilterData();
            this.getShipData();
          }
        });
        this.shipmentPageData = this.shipdata;
      }
    });
  }

  onDateSelection(date: any, datepicker) {
    this.showClear = true;
    console.log(date);
    if (!this.startDate && !this.endDate) {
      this.startDate = date;
    } else if (
      this.startDate &&
      !this.endDate &&
      date &&
      date.after(this.startDate)
    ) {
      this.endDate = date;
      this.filterData();
      datepicker.close();
    } else {
      this.endDate = null;
      this.startDate = date;
    }
  }
  isHovered(date: NgbDate) {
    return (
      this.startDate &&
      !this.endDate &&
      this.hoveredDate &&
      date.after(this.startDate) &&
      date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return (
      this.endDate && date.after(this.startDate) && date.before(this.endDate)
    );
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.startDate) ||
      (this.endDate && date.equals(this.endDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }
  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed))
      ? NgbDate.from(parsed)
      : currentValue;
  }
  onRangeSelected(value: IDateRange): void {
    this.firstFieldEmittedValue = value;
    this.startDate = this.dateFormatToddmmyyyy(
      this.firstFieldEmittedValue.start.toString()
    );
    this.endDate = this.dateFormatToddmmyyyy(
      this.firstFieldEmittedValue.end.toString()
    );
    this.date = 1;
    this.filterData();
  }
  dateFormatToddmmyyyy(str): any {
    // tslint:disable-next-line:one-variable-per-declaration
    const date = new Date(str),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join('-');
  }
  resetCalendar(datepicker) {
    this.clearFilterData();
  }
  checkPad(d) {
    return d < 10 ? '0' + d.toString() : d.toString();
  }
  clearFilterData(): any {
    this.closebar();
    this.startDate = null;
    this.endDate = null;
    this.selectedStatus = null;
    this.commodity = null
    this.selectedProduct = null;
    this.noData = false;
    //this.searchText = '';
    this.getShipData();
    this.customProductService.getFilterValues({startDate:null,endDate:null,selectedStatus:null,selectedProduct:null,selectedCommodity:null});
  }

  toggle(data: any) {
    data.toggle();
    let element3 = document.getElementsByClassName(
      'btn btn-link ngb-dp-arrow-btn'
    );
    for (let i = 0; i < element3.length; i++) {
      let value = element3[i].getAttribute('title');
      console.log(value);
      element3[i].setAttribute('title', this.setTitle(value));
    }

    let element4 = document.getElementsByTagName(
      'ngb-datepicker-navigation-select'
    )[0].children;
    for (let i = 0; i < element4.length; i++) {
      let value = element4[i].getAttribute('title');
      element4[i].setAttribute('title', this.setTitle(value));
    }
  }
  setTitle(value) {
    switch (value) {
      case 'Select year':
        return this.selectYear;
      case 'Select month':
        return this.selectMonth;
      case 'Next month':
        return this.nextMonth;
      case 'Previous month':
        return this.preMonth;
      default:
        return;
    }
  }

  clearAllFilter(): any {
    this.startDate = null;
    this.endDate = null;
    this.showClear = false;
    this.selectedStatus = null;
    this.commodity = null;
    this.selectedProduct = null;
    this.isStatusNull = true;
    this.isProductNull = true;
    this.query = null;
    this.customProductService.getFilterInput(null);
    this.currentPage = 0;
    this.pageSize = 2;
  }

  isValidLetter(k): any {
    // return ( (k >= 48 && k <= 57));
    return (k = 47);
  }

  filtersidebar() {
    // this.value = document.querySelector('sidebar').width = '295px';
    this.sidebar = false;
  }
  //   // // tslint:disable-next-line:typedef
  closebar() {
    this.sidebar = true;
  }

  omit_special_char(event): any {
    const k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));;
  }

  productsFilterData(): void {
    this.customProductService.getMasterData().subscribe(data => {
      if (data) {
        this.statusTypes = data.shipmentStatuses;
        //this.productsList = data.products;
        // this.commodityType = data.commodityType
        // this.commodityType = data.commodityType
      }
    });
    const page = 0;
    this.customProductService.getShipmentData(this.tab,page).subscribe(data=>{
      if(data && data.commodityType){
         this.commodityType = data?.commodityType?.reduce((unique, o) => {
          if(!unique.some(obj => obj.id === o.id)) {
            unique.push(o);
          }
          return unique;
      },[]);
      }else{
        this.commodityType = [];
      }
      if(data && data.materialList){
        this.materialList = data?.materialList?.reduce((unique, o) => {
         if(!unique.some(obj => obj.name === o.name)) {
           unique.push(o);
         }
         return unique;
     },[]);
     }else{
       this.materialList = [];
     }
    
    })
  }
  getShipmentResults(): void {
    this.closebar();
    this.length = this.statuslength + this.productlength +this.commoditylength + this.date;
    this.filterData();
  }
  getShipData(fromDate?, toDate?, status?, commodity?, product?, searchText?): void {
    this.showClear = true;
    this.noData = false;
    if (this.startDate != undefined && this.endDate != undefined) {
      this.fromDate =
        this.startDate?.year +
        '-' +
        this.checkPad(this.startDate?.month) +
        '-' +
        this.checkPad(this.startDate?.day);
      this.toDate =
        this.endDate?.year +
        '-' +
        this.checkPad(this.endDate?.month) +
        '-' +
        this.checkPad(this.endDate?.day);
    } else {
      this.fromDate = null;
      this.toDate = null;
    }
    // this.customProductService
    //   .getShipmentData(this.fromDate, this.toDate, status, product, searchText)
    //   .subscribe(data => {
    //     //this.shipmentPageData = data.shipmentslist;
    //     this.enableLoader = false;
    //     if (data != null && data !== undefined) {
    //       if (data.shipmentslist != null && data.shipmentslist !== undefined) {
    //         this.shipdata = data.shipmentslist;
    //         this.shipmentPageData = this.shipdata;
    //       }
    //     }
    //     if (data.shipmentslist.length === 0) {
    //       this.noData = true;
    //     } else {
    //       this.noData = false;
    //     }
    //   });
  }
  filterData(): void {
    this.showClear = true;
    this.getShipData(
      this.startDate,
      this.endDate,
      this.selectedStatus,
      this.commodity,
      this.selectedProduct,
      this.searchText
    );
    this.customProductService.getFilterValues({startDate:this.fromDate,endDate:this.toDate,selectedStatus:this.selectedStatus,selectedCommodity:this.commodity,selectedProduct:this.selectedProduct})
  }
  onCheckboxstatusChange(e, id): void {
    this.statuslength = 1;
    const checkArray: UntypedFormArray = this.checkedstatusform.get(
      'checkArray'
    ) as UntypedFormArray;
    if (e.target.checked) {
      checkArray.push(new UntypedFormControl(e.target.value));
    } else {
      let i = 0;
      checkArray.controls.forEach((item: UntypedFormControl) => {
        if (item.value === e.target.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
      this.statuslength = 0;
    }
    if (checkArray.length > 0) {
      this.statuslength = 1;
    }
    this.statusTypes.forEach(item => {
      if (item.code !== id) {
        item.selected = false;
      }
    });
    if (e.target.checked) {
      this.selectedStatus = id;
    } else {
      this.selectedStatus = null;
      this.statuslength = 0;
    }
  }

  onCheckboxproductChange(e, id): void {
    this.productlength = 1;
    const checkArray: UntypedFormArray = this.checkedproductform.get(
      'checkArray'
    ) as UntypedFormArray;

    if (e.target.checked) {
      checkArray.push(new UntypedFormControl(e.target.value));
    } else {
      let i = 0;
      checkArray.controls.forEach((item: UntypedFormControl) => {
        if (item.value === e.target.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
      this.productlength = 0;
    }
    if (checkArray.length > 0) {
      this.productlength = 1;
    }
    this.materialList.forEach(item => {
      if (item.code !== id) {
        item.selected = false;
      }
    });
    if (e.target.checked) {
      this.selectedProduct = id;
    } else {
      this.selectedProduct = null;
      this.productlength = 0;
    }
  }
  onCheckboxcommodityChange(e, idc): void {
    this.commoditylength = 1;
    const checkArray: UntypedFormArray = this.checkedcommodityform.get(
      'checkArray'
    ) as UntypedFormArray;

    if (e.target.checked) {
      checkArray.push(new UntypedFormControl(e.target.value));
    } else {
      let i = 0;
      checkArray.controls.forEach((item: UntypedFormControl) => {
        if (item.value === e.target.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
      this.commoditylength = 0;
    }
    if (checkArray.length > 0) {
      this.commoditylength = 1;
    }
    this.commodityType.forEach(item => {
      if (item.id !== idc) {
        item.selected = false;
      }
    });
    if (e.target.checked) {
      this.commodity = idc;
    } else {
      this.commodity = null;
      this.commoditylength = 0;
    }
  }
  onRangeSelectedMobile(value: IDateRange): void {
    this.firstFieldEmittedValue = value;
    this.startDate = this.dateFormatToddmmyyyy(
      this.firstFieldEmittedValue.start.toString()
    );
    this.endDate = this.dateFormatToddmmyyyy(
      this.firstFieldEmittedValue.end.toString()
    );
    this.date = 1;
  }
  onReset(event: Event): void {
    if (event !== undefined) {
      this.dateRangePicker.reset(event);
      this.dateRangePicker.toggleCalendarVisibility(false);
    }
    this.dateRangePicker.toggleCalendarVisibility(false);
    this.startDate = null;
    this.endDate = null;
    this.date = 0;
    if (!this.selectedProduct && !this.selectedStatus && !this.commodity) {
      this.clearBtn = false;
    }
  }
  clearFilterMobile(event): void {
    this.closebar();
    const checked = false;
    this.statusTypes.forEach(item => (item.selected = checked));
    this.materialList.forEach(item => (item.selected = checked));
    this.commodityType.forEach(item=>(item.selected = checked))
    this.date = 0;
    this.statuslength = 0;
    this.productlength = 0;
    this.commoditylength =0;
    this.startDate = null;
    this.endDate = null;
    this.selectedStatus = null;
    this.commodity = null;
    this.selectedProduct = null;
    this.length = this.statuslength + this.productlength + this.commoditylength + this.date;
    this.noData = false;
    //this.searchText = '';
    this.filterData();
    //this.search();
    //this.getShipData();
    //this.onReset(event);
    //this.clearFilter();
  }

  clearFilter(): any {
    this.startDate = null;
    this.endDate = null;
    this.selectedStatus = null;
    this.commodity = null;
    this.selectedProduct = null;
    this.noData = false;
    //this.searchText = '';
    this.getShipData();
  }
  clear(): void {
    this.checkedstatusform = this.fb.group({
      checkArray: this.fb.array([])
    });
    this.checkedproductform = this.fb.group({
      checkArray: this.fb.array([])
    });
    this.checkedcommodityform = this.fb.group({
      checkArray: this.fb.array([])
    });
    this.productlength = 0;
    this.statuslength = 0;
    this.commoditylength = 0;
    this.startDate = null;
    this.endDate = null;
    this.date = 0;
    this.closebar();
    this.length = this.statuslength + this.productlength + this.commoditylength + this.date;
    this.statusTypes.forEach(item => {
      item.selected = false;
    });
    this.productsList.forEach(item => {
      item.selected = false;
    });
  }
  search(): void {
    this.searchText.toLowerCase();
    if (this.searchText) {
      this.getShipData(
        this.startDate,
        this.endDate,
        this.selectedStatus,
        this.commodity,
        this.selectedProduct,
        this.searchText
      );
    } else {
      this.getShipData(
        this.startDate,
        this.endDate,
        this.selectedStatus,
        this.commodity,
        this.selectedProduct,
        this.searchText
      );
      this.noData = false;
    }
    this.customProductService.getsearchValue(this.searchText);
  }


}
